// Imports comuns do Vue
import Vue from 'ninenine-white-label/Vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './registerServiceWorker';
import SvgIcon from 'vue-svgicon';
import TnsSlider from 'ninenine-white-label/plugins/TnsSlider';
// import GLightbox from 'ninenine-white-label/plugins/GLightbox';
import SocialAuth from 'ninenine-white-label/plugins/SocialAuth';
import { Card, Button, Collapse, Tabs, Modal, Nav } from 'bootstrap-vue/es/components';
import { Scrollspy, Tooltip } from 'bootstrap-vue/es/directives';
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import Selectize from 'vue2-selectize';
import VueMoment from 'vue-moment';
import VueCroppie from 'vue-croppie';
import VueIntercom from 'vue-intercom';
import 'croppie/croppie.css';
// import { VLazyImagePlugin } from "v-lazy-image";
import "vue-material-design-icons/styles.css";
import VueGtag from "vue-gtag";


Vue.prototype.socialIds = {
  facebook: process.env.NODE_ENV == "development" ? "537945388144713" : "537945388144713",
  linkedin: process.env.NODE_ENV == "development" ? "77lyvm1kw07d9c" : "77lyvm1kw07d9c"
};

Vue.use(SvgIcon, {
  tagName: 'svgicon'
});

Vue.use(TnsSlider);
// Vue.use(GLightbox);

Vue.use(SocialAuth, {
  facebook: Vue.prototype.socialIds.facebook
});

Vue.use(Card);
Vue.use(Button);
Vue.use(Collapse);
Vue.use(Tabs);
Vue.use(Modal);
Vue.use(Nav);
Vue.use(Scrollspy);
Vue.use(Tooltip);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);
Vue.use(VueMoment);
Vue.use(VueCroppie);
Vue.component('selectize', Selectize);
Vue.use(VueIntercom, { appId: 'nq6fayk7' });
// Vue.use(VLazyImagePlugin);
Vue.use(VueGtag, {
  config: { id: "" },
  includes: [
    { id: 'G-P6LCYDFPYC' }, // ninenine-ga
  ]
}, router);

// Funcao auxiliar
Vue.prototype.delay = function(time){
  return new Promise( resolve => {
    setTimeout(() => {
      resolve(true)
    }, time)
  })
}

Vue.prototype.removeAutoFillSelectize = function(){
  Array.from(document.querySelectorAll('input')).map( element => {
    element.setAttribute('autocomplete', 'no')
  })
}

Vue.prototype.goToInvalidField = function(context){
  setTimeout(() => {
    const element = context || document;
    Array.from(element.querySelectorAll(".is-invalid")).some(field => {
      field.querySelector('input').focus();
      return field;
    });
  }, 400)
}

Vue.prototype.dateRange = function(dateFrom, dateTo){
  let a = Vue.prototype.$moment(dateTo);
  let b = Vue.prototype.$moment(dateFrom);
  let message = '';

  let years = a.diff(b, 'year');
  b.add(years, 'years');

  let months = a.diff(b, 'months');
  b.add(months, 'months');

  if(years > 0) message += years + ' anos '
  if(months > 0) message += months + ' meses '

  return message
}

Vue.mixin({
  methods: {
    subscribeUser: async function (opportunity) {
      const opportunityId = this.$route.params.id.match(/\d+/)[0];
      const opportunity_questions = JSON.parse(localStorage.getItem('opportunity_questions'));

      if (!opportunity_questions || opportunity_questions.error == true) {
        this.$router.push(`/vagas/${this.$route.params.id}/inscricao`);
        return;
      }

      const hasSource = localStorage.getItem('source');
      const indicationForm = localStorage.getItem('indication_form');

      const subscriptionRequest = await this.$store.dispatch('opportunities/subscriptionNew', {
        opportunity_id: opportunityId,
        questions: opportunity_questions.data.questions,
        source: hasSource ? hasSource : this.$store.state.source,
        indication_form: hasSource && indicationForm ? JSON.parse(indicationForm)['data'] : null,
        send_confirmed_email: true
      });

      if (subscriptionRequest.error) {
        if (subscriptionRequest.error.message) {
          this.$swal('Uoops', subscriptionRequest.error.message, 'error');
        } else {
          this.$swal('Uoops', 'Ocorreu um erro ao processar sua candidatura... Tente novamente mais tarde.', 'error');
        }

        this.$router.push(`/vagas/${this.$route.params.id}/inscricao`);
      } else {
        if (hasSource) localStorage.removeItem('source');
        if (indicationForm) localStorage.removeItem('indication_form');
        this.$store.commit('user/SET_FOLLOWER', true);
        this.$router.push(`/inscricao-confirmada?vaga=${this.$store.state.opportunities.currentOpportunity.title}&id=${opportunityId}`);
      }

      return subscriptionRequest;
    },
  },
})

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    if (!this.$store.state.user.isAuth) {
      this.$intercom.boot({
        name: 'Candidate',
        custom_domain: this.$store.state.source,
      });
    } else {
      const user_hash = this.$CryptoJS.HmacSHA256(this.$store.state.user.profile.email, "a8Lf6zmvjJCDmBu5kEtJ57D5Ju8GiMegw7NQpxcp").toString();

      this.$intercom.boot({
        user_hash,
        name: this.$store.state.user.profile.name,
        email: this.$store.state.user.profile.email,
        custom_domain: this.$store.state.source,
      });
    }
  },
}).$mount('#app');
